module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showVersionsMenu) ? _c('div', {
    staticClass: "task-overview"
  }, [_c('div', {
    staticClass: "to-versions"
  }, [(_vm.isUserSchoolAdmin && _vm.sortedVersions.length < 1 && _vm.savedStatements.length < 1) ? _c('button', {
    staticClass: "d-drop-box to-versions__save-bttn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openSaveModal
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('vue2.task_versions.save_version')) + "\n    ")]) : _c('DDropdown', {
    attrs: {
      "isShowDots": false
    }
  }, [_c('div', {
    staticClass: "d-drop-box",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.versions')) + " "), _c('span', {
    staticClass: "icon-arrow-down52"
  })]), _vm._v(" "), _c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [(_vm.savedStatements.length) ? [_c('li', {
    staticClass: "to-versions__heading"
  }, [_vm._v("Opgørelser af ansættelse")]), _vm._v(" "), _vm._l((_vm.savedStatements), function(statement) {
    return _c('li', {
      key: 'statement-' + statement.id,
      on: {
        "click": function($event) {
          _vm.activeStatement = statement
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.statementTitle(statement)) + "\n          ")])
  }), _vm._v(" "), (_vm.sortedVersions.length) ? _c('li', {
    staticClass: "to-versions__heading to-versions__save--divider"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.task_versions.versions')) + "\n          ")]) : _vm._e()] : _vm._e(), _vm._v(" "), _vm._l((_vm.sortedVersions), function(version) {
    return _c('li', {
      key: version.id,
      on: {
        "click": function($event) {
          return _vm.selectVersion(version)
        }
      }
    }, [_vm._v("\n          " + _vm._s(version.vTitle) + "\n        ")])
  }), _vm._v(" "), (_vm.isUserSchoolAdmin) ? _c('li', {
    staticClass: "to-versions__save",
    class: {
      'to-versions__save--divider': _vm.sortedVersions.length > 0 || _vm.savedStatements.length > 0
    },
    on: {
      "click": _vm.openSaveModal
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.task_versions.save_new_version')) + "\n        ")]) : _vm._e()], 2)])], 1), _vm._v(" "), (_vm.activeVersion) ? _c('DModal', {
    attrs: {
      "showClose": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "isPrintable": true
    },
    on: {
      "close": function($event) {
        _vm.activeVersion = null
      }
    }
  }, [_c('div', {
    staticClass: "to-versions__modal text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "to-versions__modal__header no-print"
  }, [_c('div', {
    staticClass: "to-versions__modal__header__left pad-1-left"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeVersionId),
      expression: "activeVersionId"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeVersionId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selectVersionFromId(_vm.activeVersionId)
      }]
    }
  }, _vm._l((_vm.sortedVersions), function(version) {
    return _c('option', {
      key: version.id,
      domProps: {
        "value": version.id
      }
    }, [_vm._v("\n            " + _vm._s(version.vTitle) + "\n          ")])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "pad-1-left"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.task_versions.saved_message')) + ": " + _vm._s(_vm.versionDateFormatted) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "to-versions__modal__header__right"
  }, [_c('DDropdown', {
    attrs: {
      "isBottomStart": false
    }
  }, [_c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('li', {
    on: {
      "click": _vm.printVersion
    }
  }, [_c('span', {
    staticClass: "icon-printer3"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.print_all_calendars.print')) + "\n              ")]), _vm._v(" "), (_vm.isUserSchoolAdmin) ? _c('li', {
    staticClass: "d-item-warning",
    on: {
      "click": _vm.setWarningToDelete
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.task_versions.delete_message')) + "\n              ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle ww-modal__header__close",
    on: {
      "click": function($event) {
        _vm.activeVersion = null
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])], 1)]), _vm._v(" "), _c('div', {
    ref: "versionBody",
    staticClass: "to-versions__modal__body"
  }, [_c('TaskOverviewUser', {
    attrs: {
      "user": _vm.user,
      "version": _vm.activeVersion
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.activeStatement) ? _c('DModal', {
    attrs: {
      "appendToBody": true,
      "isBgOverlay": true,
      "showClose": false
    },
    on: {
      "close": _vm.closeStatement
    }
  }, [_c('div', {
    staticClass: "do-modal to-statement text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "do-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.activeStatementTitle))]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle ww-modal__header__close",
    on: {
      "click": _vm.closeStatement
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__body to-statement__body"
  }, [_c('AssignHoursWorkedHoursStatement', {
    attrs: {
      "schoolId": _vm.schoolId,
      "users": [_vm.user],
      "savedStatement": _vm.activeStatement
    },
    on: {
      "title": function($event) {
        _vm.activeStatementTitle = $event
      }
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isDeleteWarningActive) ? _c('DModal', {
    staticStyle: {
      "z-index": "999999999"
    },
    attrs: {
      "appendToBody": true,
      "isBgOverlay": true,
      "showClose": false
    }
  }, [_c('div', {
    staticClass: "brutto-warning text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "brutto-warning__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.common.are_you_sure_you_want_to_delete')) + "?")]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle doc-modal__close",
    on: {
      "click": function($event) {
        _vm.isDeleteWarningActive = false
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-warning__body"
  }, [_c('svg', {
    staticClass: "tw-icon tw-icon--red",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "9",
      "x2": "12",
      "y2": "13"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "12",
      "y1": "17",
      "x2": "12.01",
      "y2": "17"
    }
  })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.confirm_delete_message')) + " " + _vm._s(_vm.activeVersion.vTitle) + "?")]), _vm._v(" "), _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.task_versions.delete_warning_message')) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "brutto-warning__footer"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.isDeleteWarningActive = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn--warning bttn-danger bttn-primary--small",
    class: [{
      'bttn--loading': _vm.isSaving
    }],
    on: {
      "click": _vm.deleteVersion
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.delete')) + "\n      ")])])])]) : _vm._e(), _vm._v(" "), (_vm.isSaveModalActive) ? _c('DModal', {
    attrs: {
      "appendToBody": true,
      "isBgOverlay": true,
      "showClose": false
    },
    on: {
      "close": _vm.closeSaveModal
    }
  }, [_c('div', {
    staticClass: "to-save-version text-dark",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "to-save-version__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.task_versions.save_task_overview_version')))]), _vm._v(" "), _c('div', {
    staticClass: "icon__bg-circle doc-modal__close",
    on: {
      "click": _vm.closeSaveModal
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "to-save-version__body"
  }, [_c('h4', {
    staticClass: "marg-05-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.version_title')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newVersionTitle),
      expression: "newVersionTitle"
    }],
    ref: "version_name_input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newVersionTitle)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.saveVersion.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newVersionTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-desc"
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_versions.auto_name_description')))])]), _vm._v(" "), _c('div', {
    staticClass: "to-save-version__footer"
  }, [_c('button', {
    on: {
      "click": _vm.closeSaveModal
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn-primary",
    class: {
      'bttn--loading': _vm.isSaving
    },
    on: {
      "click": _vm.saveVersion
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue2.common.save')) + "\n        ")])])])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51914942!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/TaskOverview/TaskOverview.vue
// module id = 1917
// module chunks = 1